<script>
    import WarningColor from '../WarningColor.svelte';
    import IconRemove from './IconRemove.svelte';

    export let scale = 1;
</script>

<WarningColor>
    <IconRemove {scale} on:click/>
</WarningColor>
